import { render } from "./ResultsCount.vue?vue&type=template&id=3a2ee920"
import script from "./ResultsCount.vue?vue&type=script&lang=js"
export * from "./ResultsCount.vue?vue&type=script&lang=js"

import "./ResultsCount.vue?vue&type=style&index=0&id=3a2ee920&lang=scss"
script.render = render

export default script